import { DateTimeConstants } from '../constants/DateTimeConstants';

interface RelativeDate {
  offset: number;
  unit: RelativeDate.TimeUnit;
  direction: RelativeDate.TimeDirection;
}

namespace RelativeDate {
  export enum TimeDirection {
    AFTER = 'from now',
    BEFORE = 'ago'
  }

  export enum TimeUnit {
    MINUTES = 'minute',
    HOURS = 'hour',
    DAYS = 'day',
    WEEKS = 'week',
    MONTHS = 'month',
    YEARS = 'year'
  }

  const UnitToMillisMap: { [key in TimeUnit]: number } = {
    [TimeUnit.MINUTES]: DateTimeConstants.MILLIS_PER_MINUTE,
    [TimeUnit.HOURS]: DateTimeConstants.MILLIS_PER_HOUR,
    [TimeUnit.DAYS]: DateTimeConstants.MILLIS_PER_DAY,
    [TimeUnit.WEEKS]: DateTimeConstants.MILLIS_PER_WEEK,
    [TimeUnit.MONTHS]: DateTimeConstants.MILLIS_PER_MONTH,
    [TimeUnit.YEARS]: DateTimeConstants.MILLIS_PER_YEAR
  };

  export function toMillis({ offset, unit, direction }: RelativeDate): number {
    return offset * UnitToMillisMap[unit] * (direction === TimeDirection.BEFORE ? -1 : 1);
  }

  export function formatUnit(offset: number, unit: string): string {
    return offset === 1 ? unit : `${unit}s`;
  }

  export function format({ offset, unit, direction }: RelativeDate, showDirection: boolean = true): string {
    return [offset, formatUnit(offset, unit), showDirection && direction].filter(Boolean).join(' ');
  }

  export function daysAgo(offset: number): RelativeDate {
    return {
      offset,
      unit: RelativeDate.TimeUnit.DAYS,
      direction: RelativeDate.TimeDirection.BEFORE
    };
  }
}

export { RelativeDate };
